import { Store } from 'effector';

export const createNot = (store: Store<boolean>) => {
  return store.map((x) => !x);
};
